var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vehicle-image__container"},[_c('img',{staticClass:"vehicle-image__trimmed",class:{ 'vehicle-image__blurred': _vm.blurred },attrs:{"src":_vm.chatMessage.options.imageURL}})])
}
var staticRenderFns = []

export { render, staticRenderFns }